import { Question } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { QuestionCompetencySkillsMap } from '../../../../stores';
import { ListEntryWithIdentity, ListFieldInfo } from '../../../common/list/list-types';

export type QuestionListEntry = ListEntryWithIdentity<Question>;

export const QuestionListView: ListFieldInfo<QuestionListEntry, QuestionCompetencySkillsMap>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'link',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'content',
    label: 'Content',
    /// TODO: kind: "i18nMarkdown",
    kind: 'text',
    displayed: true,
    sortable: true
  },
  {
    name: 'competency',
    label: 'Competency',
    kind: 'mapped',
    map: (entry, data) => {
      if (data && entry.skillId !== null) {
        const skill = data.skills.get(entry.skillId);
        if (skill) {
          const competency = data.competencies.get(skill.competencyId);
          if (competency) {
            return competency.fullName;
          }
        }
      }
      return '-';
    },
    displayed: true,
    sortable: true
    //TODO:        // searchable: true
  },
  {
    name: 'skill',
    label: 'Skill',
    kind: 'mapped',
    map: (entry, data) => {
      if (data && entry.skillId !== null) {
        const skill = data.skills.get(entry.skillId);
        if (skill) {
          return skill.name;
        }
      }
      return '-';
    },
    displayed: true,
    sortable: true
    //TODO:        // searchable: true
  },
  {
    name: 'answerType',
    label: 'Answer Type',
    kind: 'mapped',
    map: entry => {
      switch (entry.scoring.kind) {
        case 'multiResponse':
          return 'Multi-Response';
        case 'orderedResponse':
          return 'Ordered Response';
        case 'singleResponse':
          return 'Single Response';
        default:
          return 'Submit Only';
      }
    },
    displayed: true,
    sortable: true
    //TODO:        // searchable: true
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/question-list/question-list-view.ts